<template>
  <div class="services_page">
    <div class="headline -page">
      <h1 class="headline_title title-fade">Организация<br/> <span>мероприятий</span></h1>
      <p class="headline_text subtitle-fade">Всё в лучшем виде</p>
      <div class="arrow-fade">
        <div class="headline_arrow"></div>
      </div>
    </div>
    <div class="image-fade first">
      <div class="page_big-image jarallax" data-jarallax data-speed="-0.05" data-jarallax-element="50">
        <img class="jarallax-img" src="/src/assets/img/e1.jpg" alt="Организация мероприятий">
      </div>
    </div>

    <div class="page_content">
      <div class="lines">
        <div class="lines_block"></div>
        <div class="lines_block"></div>
      </div>
      <div class="waypoint" v-waypoint="{ active: true, callback: onWaypoint}">
        <div class="page_block left-title padding">
          <p>Корпоративные мероприятия</p>
          <div class="page_block-number numeric jarallax" data-jarallax-element="-40">01</div>
        </div>
        <div class="page_block right padding mobile-small-padding">
          <p>Торжества с&nbsp;большим количеством гостей&nbsp;&mdash; это, в&nbsp;первую
            очередь, большая ответственность. Поэтому наша команда скрупулезно создает
            концепции для корпоративных мероприятий, чтобы каждый пришедший почувствовал
            себя желанным гостем.</p>
          <p>Доверьте команде агентства &laquo;Антуриум&raquo; выбор места, оформление,
            праздничную программу и&nbsp;другие элементы торжества, и&nbsp;мы&nbsp;гарантируем
            вам захочется провести с&nbsp;нами еще не&nbsp;одно корпоративное мероприятие.</p>
        </div>
      </div>
    </div>
    <div class="page_content">
      <div class="lines">
        <div class="lines_block"></div>
        <div class="lines_block"></div>
      </div>
      <div class="waypoint" v-waypoint="{ active: true, callback: onWaypoint}">
        <div class="page_block right-title padding">
          <p>Частные мероприятия</p>
          <div class="page_block-number numeric jarallax" data-jarallax-element="-40">02</div>
        </div>
        <div class="page_block right padding mobile-small-padding">
          <p>Мы&nbsp;пока что не&nbsp;знаем, какое мероприятие вы&nbsp;планируете, но&nbsp;уже
            понимаем, как сделать его запоминающимся для вас и&nbsp;ваших гостей. На&nbsp;наш
            взгляд, частные торжества должны разительно отличаться от&nbsp;других видов мероприятий.
            Они могут быть полностью посвящены виновнику торжества, известны заранее
            или стать великолепным сюрпризом. </p>
          <p>В&nbsp;любом случае, каждая деталь, каждая минута этого праздника будет проработана
            на&nbsp;100&nbsp;%. Для творческого полета наших сотрудников, чем сложнее вы&nbsp;
            поставите
            перед нами задачу, тем интереснее. Только создавая уникальные и&nbsp;многогранные проекты,
            мы&nbsp;зарабатываем любовь и&nbsp;репутацию среди наших клиентов.</p>
        </div>
      </div>
    </div>

    <div class="page_content">
      <div class="lines">
        <div class="lines_block"></div>
        <div class="lines_block"></div>
      </div>
      <div class="waypoint" v-waypoint="{ active: true, callback: onWaypoint}">
        <div class="page_block left-title padding">
          <p>Детские праздники</p>
          <div class="page_block-number numeric jarallax" data-jarallax-element="-40">03</div>
        </div>
        <div class="page_block right padding mobile-small-padding">
          <p>День рождения, Новогодняя ёлка или любой другой тематический детский
            праздник&nbsp;&mdash;
            мы&nbsp;знаем, как сделать так, чтобы заливистый смех и&nbsp;отличное настроение стали
            верными
            спутниками торжества для ваших детей. Мы&nbsp;с&nbsp;радостью подберем для вас
            аниматоров или
            фокусников, порекомендуем лучшие мастер-классы, чтобы дети не&nbsp;заскучали,
            а&nbsp;также
            сможем ответить на&nbsp;все ваши вопросы в&nbsp;процессе подготовке к&nbsp;празднику.</p>
          <p>В&nbsp;нашей команде уверены, что самые искренние и&nbsp;чистые эмоции дарят нам
            дети, поэтому
            мы&nbsp;так стремимся поразить не&nbsp;только вас, но&nbsp;и&nbsp;ваших ребятишек.</p>
        </div>
        <div class="page_block center quote">
          <p>Чтобы обсудить все детали, пожалуйста, просто оставьте нам ваши контактные
            данные&nbsp;&mdash;
            мы&nbsp;с&nbsp;радостью свяжемся с&nbsp;вами.</p>
        </div>
      </div>
    </div>

    <Form />
  </div>
</template>

<script>
import Form from 'components/form/Form';
import { onWaypoint, parallax } from 'src/mixins';

export default {
  mixins: [onWaypoint, parallax],
  components: {
    Form,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/services/Events.vue